import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const initialize = useAuthStore((state) => state.initialize);
  
  // Ensure the auth state is initialized
  React.useEffect(() => {
    initialize();
  }, [initialize]);

  return isLoggedIn ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;